export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    (function($) {
      if( document.getElementsByClassName('slider').count != 0 ){

        $('.slider--testimonial').slick({
          arrows: true,
          prevArrow: $('.testimonials__button.left'),
          nextArrow: $('.testimonials__button.right'),
          adaptiveHeight: true,
        })
      }

      if( document.getElementsByClassName('accordion').count != 0 ){
        var allPanels = $('.accordion > dd').hide();

        $('.accordion > dt').click(function() {
            var $this = $(this).find('a');
            var $target =  $this.parent().next();

            if(!$target.hasClass('active')){
              $('.accordion > dt').removeClass('active');
              allPanels.removeClass('active').slideUp();
              $target.addClass('active').slideDown();
              $this.parent().addClass('active');
            }

          return false;
        });
        $('.accordion > dt').first().click();
      }

      if( $('.btn').length > 0) {
        $('.btn').each(function(){
          if( $(this).attr('href').charAt(0) == '#' ){
            $(this).addClass('btn--anchor');
          }

          $('.btn--anchor').on('click', function() {
            let thisAnchor = $(this).attr('href');
            $('html, body').animate({
                scrollTop: ($(thisAnchor).offset().top - 80),
            }, 2000);
          });
        });
      }

      if( $('.areas-of-law--expanded').length > 0 ){
        $('.areas-of-law h3').on('click', function(){
          if( $(this).hasClass('expanded') ){
            $(this).removeClass('expanded');
          }else{
            $(this).addClass('expanded');
          }
        });

        $('.areas-of-law h3 > a').on('click', function(event){
          event.stopPropagation();
        });
      }

      /*Scroll to top when arrow up clicked BEGIN*/
      $(window).scroll(function() {
        var height = $(window).scrollTop();
        if (height > 100) {
          $('header.banner').addClass('scrolled');
        } else {
          $('header.banner').removeClass('scrolled');
        }
      });

      $('#back-to-top').click(function(event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        return false;
      });
      /*Scroll to top when arrow up clicked END*/

      $('.menu-item-has-children').on('click', function(){
        event.stopPropagation();
        if( $(this).hasClass('menu-item-opened') ){
          $(this).removeClass('menu-item-opened');
        }else{
          $(this).addClass('menu-item-opened');
        }
      });

      $('.menu-item-has-children > a').on('click', function(event){
        event.stopPropagation();
      });

      let mq = window.matchMedia('(min-width: 1024px)');
      $(window).on('resize', function(){

        setTimeout(function(){
          if( mq.matches ){
            if( $('.text-plus-image').length > 0 ) {
              $('.text-plus-image').each(function(){
                $(this).find('.image-content').hide();
                let height = $(this).find('.text-content').innerHeight();
                $(this).find('.image-content').css('height', height);
                $(this).find('.image-content').show();
              });
            }
          }
        },1000);

      });

      if( $('.lawyer-filter').length > 0 ){

        $('.lawyer-filter input').on('change', function(){
          let $radioValue = $(this).attr('value');
          if( $radioValue == 'all' ){
            $('.lawyers-listings__lawyers .lawyer').each(function(){
              $(this).show();
            });
          }else{
            $('.lawyers-listings__lawyers .lawyer').each(function(){
              if( $(this).hasClass($radioValue) ){
                $(this).show();
              }else{
                $(this).hide();
              }
            });
          }
        });

      }

    })(jQuery);



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js